import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../../context/CookieConsentContext';
import './FooterLegalBar.css';

const FooterLegalBar = ({ variant = 'dark' }) => {
  const { openCookieSettings } = useCookieConsent();

  return (
    <div className={`footer-legal-bar footer-legal-bar--${variant}`}>
      <h4 className="footer-legal-title">Terms and settings</h4>
      <nav className="footer-legal-nav" aria-label="Terms and settings">
        <Link to="/privacy" className="footer-legal-link">
          Privacy Notice
        </Link>
        <span className="footer-legal-separator" aria-hidden="true">
          ·
        </span>
        <Link to="/terms" className="footer-legal-link">
          Terms of Service
        </Link>
        <span className="footer-legal-separator" aria-hidden="true">
          ·
        </span>
        <Link to="/cookies" className="footer-legal-link">
          Cookies Policy
        </Link>
        <span className="footer-legal-separator" aria-hidden="true">
          ·
        </span>
        <button type="button" className="footer-legal-link footer-legal-link--button" onClick={openCookieSettings}>
          Cookie settings
        </button>
      </nav>
    </div>
  );
};

export default FooterLegalBar;
